
import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(page = 1, filters = {}) {
        const params = { page, ...filters };
        return axios.get(`${API_URL}/production-orders`, { params, headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/production-orders/${id}`, { headers: authHeader() });
    },
    saveAssignmentSignature(assignmentId, data) {
        return axios.put(`${API_URL}/production-order-assignments/${assignmentId}/signature`, data, { headers: authHeader() });
    },
    send(remissionIds, categoryId = null) {
        const payload = { remission_ids: remissionIds };
        if (categoryId) payload.category_id = categoryId;
        return axios.post(`${API_URL}/production-orders/send`, payload, { headers: authHeader() });
    },
    preview(remissionIds, categoryId = null) {
        const params = { remission_ids: remissionIds };
        if (categoryId) params.category_id = categoryId;
        return axios.get(`${API_URL}/production-orders/preview`, { params, headers: authHeader() });
    },
    updateStatus(id, status) {
        return axios.put(`${API_URL}/production-orders/${id}/status`, { status }, { headers: authHeader() });
    },
    updateObservation(id, observation) {
        return axios.put(`${API_URL}/production-orders/${id}/observation`, { observation }, { headers: authHeader() });
    },
    updateAssignedUser(id, assignedUserId) {
        return axios.put(`${API_URL}/production-orders/${id}/assigned-user`, { assigned_user_id: assignedUserId }, { headers: authHeader() });
    },
    createAssignment(orderId, data) {
        return axios.post(`${API_URL}/production-orders/${orderId}/assignments`, data, { headers: authHeader() });
    },
    updateAssignment(assignmentId, data) {
        return axios.put(`${API_URL}/production-order-assignments/${assignmentId}`, data, { headers: authHeader() });
    },
    completeAssignment(assignmentId, data) {
        return axios.put(`${API_URL}/production-order-assignments/${assignmentId}/complete`, data, { headers: authHeader() });
    },
    updateAssignmentDetail(detailId, data) {
        return axios.put(`${API_URL}/production-order-assignment-details/${detailId}`, data, { headers: authHeader() });
    },
    deleteAssignment(assignmentId) {
        return axios.delete(`${API_URL}/production-order-assignments/${assignmentId}`, { headers: authHeader() });
    },
    destroy(id) {
        return axios.delete(`${API_URL}/production-orders/${id}`, { headers: authHeader() });
    },
    getPendingItemsGrouped(ids = []) {
        const query = ids.length ? `?ids[]=${ids.join('&ids[]=')}` : '';
        return axios.get(`${API_URL}/production-orders/export-pending-items-grouped${query}`, { headers: authHeader(), responseType: 'blob' });
    },
};
